<template>
  <section class="cta_cta">
    <div class="container">
      <div class="cta_cta__inner" :class="[ctaCount]">
        <a
          class="cta_cta__inner__text"
          v-for="(cta, index) in parsedCtas"
          :key="index"
          :class="cta.theme"
          :href="cta.link.url"
          :target="cta.link.target"
        >
          <div class="image" v-if="cta.image">
            <img :src="cta.image.url" />
          </div>

          <div class="wrapper" :class="{ 'has-image': cta.image }">
            <div class="content_container">
              <div class="inner">
                <h3 v-if="cta.title" v-html="cta.title"></h3>

                <div class="caption" v-if="cta.text" v-html="cta.text"></div>
              </div>

              <a
                v-if="cta.link"
                :href="cta.link.url"
                :target="cta.link.target"
                v-html="cta.link.title"
              ></a>
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      theModalStatus: false,
    };
  },

  props: {
    title: {},
    text: {},
    secondary_button: {},
    ctas: {},
  },

  computed: {
    parsedCtas() {
      if (this.ctas) {
        return JSON.parse(this.ctas);
      } else {
        return null;
      }
    },

    ctaCount() {
      if (this.parsedCtas.length === 2) {
        return 'two';
      } else if (this.parsedCtas.length === 3) {
        return 'three';
      } else {
        return 'four';
      }
    },
  },

  watch: {},

  methods: {
    getModalData(arg) {
      this.theModalStatus = arg;
      return arg;
    },
  },

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.cta_cta {
  /* overflow: hidden; */

  @media (max-width: $mobile-xl) {
    padding: 0;
  }

  /* .container {
		@media (max-width: $mobile-xl) {
			padding: 0;
			margin: 0;
			max-width: 100%;
		}
	} */

  &__inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    grid-column: 1 / span 12;

    @media (max-width: $mobile-xl) {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 16px;
      grid-column: span 4;
    }

    &.two {
      grid-template-columns: 1fr 1fr;
      grid-column: 1 / span 12;

      @media (max-width: $mobile-xl) {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 16px;
        grid-column: span 4;

        .cta_cta__inner__text {
          grid-column: span 1;
        }
      }

      @media (max-width: $mobile) {
        grid-template-columns: 1fr;
        column-gap: 0;
        row-gap: 16px;
        grid-column: span 4;

        .cta_cta__inner__text {
          grid-column: span 1;
        }
      }
    }

    &.three {
      grid-template-columns: 1fr 1fr 1fr;
      grid-column: 1 / span 12;

      @media (max-width: $mobile-xl) {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 16px;
        grid-column: span 4;

        .cta_cta__inner__text {
          grid-column: span 1;
        }
      }

      @media (max-width: $mobile) {
        grid-template-columns: 1fr;
        column-gap: 0;
        row-gap: 16px;
        grid-column: span 4;

        .cta_cta__inner__text {
          grid-column: span 1;
        }
      }
    }

    &.four {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-column: 1 / span 12;

      @media (max-width: $mobile-xl) {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 16px;
        grid-column: span 4;

        .cta_cta__inner__text {
          grid-column: span 1;
        }
      }

      @media (max-width: $mobile) {
        grid-template-columns: 1fr;
        column-gap: 0;
        row-gap: 16px;
        grid-column: span 4;

        .cta_cta__inner__text {
          grid-column: span 1;
        }
      }
    }

    &__text {
      grid-column: span 1;
      opacity: 1;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }

      &.dark {
        background: var(--dark-purple);
        transition: 0.2s ease all;

        &:hover {
          background: #5b5266;
          transition: 0.2s ease all;

          /* h3 {
            color: var(--dark-purple);
            transition: 0.2s ease all;
          } */

          /* &::v-deep {
            p,
            li,
            a,
            span {
              color: var(--dark-purple);
              transition: 0.2s ease all;
            }
          } */
        }

        .caption {
          z-index: 10;
          margin-bottom: 15px;

          &::v-deep {
            p,
            li,
            a,
            span {
              color: #888888;
            }
          }
        }
      }

      &.light {
        background: var(--light-grey);
        transition: 0.2s ease all;

        h3 {
          color: var(--dark-purple);
          transition: 0.2s ease all;
        }

        &:hover {
          background: #cbcbcb;
          transition: 0.2s ease all;

          h3 {
            color: var(--dark-purple);
            transition: 0.2s ease all;
          }

          &::v-deep {
            p,
            li,
            a,
            span {
              color: var(--dark-purple);
              transition: 0.2s ease all;
            }
          }
        }

        .caption {
          z-index: 10;
          margin-bottom: 15px;

          &::v-deep {
            p,
            li,
            a,
            span {
              color: #888888;
            }
          }
        }
      }

      font: normal normal 300 18px/28px var(--primary-font-family);
      position: relative;
      overflow: hidden;

      @media (max-width: $mobile-xl) {
        gap: var(--gutter-mobile);
        order: 1;
      }

      h3 {
        color: var(--white);
        margin: 0;
        margin-bottom: 5px;
        z-index: 10;
      }

      @media (max-width: $mobile-xl) {
        grid-column: 1 / span 4;
        // padding: 0 var(--spacer);

        h4 {
          text-align: left;
        }

        .the_subtitle {
          text-align: center;
        }
      }

      .wpforms-container-full,
      .wpcf7-form {
        margin-top: var(--spacer);
      }

      .caption {
        z-index: 10;
        margin-bottom: 15px;

        &::v-deep {
          p,
          li,
          a,
          span {
            margin: 0;
            font: normal normal normal 16px/24px var(--primary-font-family);
            color: var(--white);

            @media (max-width: $mobile-xl) {
              text-align: left;
            }
          }
        }

        .dark & {
          &::v-deep {
            p,
            li,
            a,
            span {
              color: var(--dark-purple);
            }
          }
        }
      }

      .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(.has-image) {
          height: 100%;
        }
      }

      .content_container {
        padding: 30px 45px;
        min-height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @media (max-width: $mobile-xl) {
          padding: 16px;
        }
      }

      a {
        color: var(--green);
        font-size: 16px;
        font-weight: 400;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      .content_device {
        position: absolute;
        right: 0;
        bottom: 0;

        @media (max-width: $mobile-xl) {
          height: 112px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/CtaCta.vue